import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Transition } from 'react-transition-group';
import { forceCheck } from 'react-lazyload';
import { empty } from 'ramda';
import { ThemeProvider } from 'styled-components';
import { TransitionState } from '../../../theme/transitions';
import { TRANSITION_TOTAL_DURATION } from './animated.constants';

export class Animated extends PureComponent {
  static propTypes = {
    disableAnimation: PropTypes.bool,
    visible: PropTypes.bool,
    children: PropTypes.any,
    totalDuration: PropTypes.number,
    onEnter: PropTypes.func,
    onEntered: PropTypes.func,
    onExit: PropTypes.func,
    onExited: PropTypes.func,
  };

  static defaultProps = {
    onEnter: empty,
    onEntered: empty,
    onExit: empty,
    onExited: empty,
    totalDuration: TRANSITION_TOTAL_DURATION,
  };

  state = {
    isTransitioning: false,
  };

  get stateChangeCallbacks() {
    return {
      onEnter: this.handleOnEnter,
      onEntered: this.handleOnEntered,
      onExit: this.handleOnExit,
      onExited: this.handleOnExited,
    };
  }

  enterTimeout = null;

  handleOnExit = () => {
    clearTimeout(this.enterTimeout);
    this.setState({ isTransitioning: true });
    this.props.onExit();
  };

  handleOnExited = () => {
    this.setState({ isTransitioning: false });
    this.props.onExited();
  };

  handleOnEnter = () => {
    this.setState({ isTransitioning: true });
    this.props.onEnter();
  };

  handleOnEntered = () => {
    clearTimeout(this.enterTimeout);
    this.enterTimeout = setTimeout(() => {
      this.props.onEntered();
      forceCheck();
      setTimeout(() => this.setState({ isTransitioning: false }));
    }, this.props.totalDuration);
  };

  renderWithAnimation = renderContent => (
    <Transition
      in={this.props.visible}
      timeout={{
        appear: 0,
        enter: 0,
        exit: this.props.totalDuration,
      }}
      unmountOnExit
      {...this.stateChangeCallbacks}
    >
      {renderContent}
    </Transition>
  );

  renderWithoutAnimation = renderContent => this.props.visible && renderContent(TransitionState.ENTERED);

  render() {
    const renderFn = this.props.disableAnimation ? this.renderWithoutAnimation : this.renderWithAnimation;

    return renderFn(transitionState => (
      <ThemeProvider theme={{ transitionState, isTransitioning: this.state.isTransitioning }}>
        <Fragment>{this.props.children}</Fragment>
      </ThemeProvider>
    ));
  }
}
